/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import axios from 'axios';
import mbpUtil from 'mbp-api-util';

const RESOURCE_GET_CAD_RATE = '/getCADRate';
const wcHost = mbpUtil.getEnv('APP_WC_HOST');

/* eslint-disable object-shorthand */
const getCADRate = async (jwtToken) => axios.get(`https://${wcHost}/r/api/mbp-canada-checkout${RESOURCE_GET_CAD_RATE}`, { headers: { authorization: `Bearer ${jwtToken}` } }).then((res) => res);

export default getCADRate;
